import {
  SET_CURRENT_LIST_ID,
} from './types';

export const setCurrentListId = listId => ({
  type: SET_CURRENT_LIST_ID,
  payload: listId,
});
